export const RequestHeader = Object.freeze({
  X_PROJECT: "x-project",
  CONTENT_TYPE: "content-type",
  X_IDEMPOTENCY_KEY: "x-idempotency-key",
  X_REQUESTED_WITH: "x-requested-with",
  AUTHORIZATION: "authorization",
  ACCEPT: "accept",
  CACHE_CONTROL: "cache-control",
  PRAGMA: "pragma",
  EXPIRES: "expires",
});
